/** NIST / FRVT scenario modes and BioSDK request flag keys. */

export const NIST_FACE_SCENARIO_SINGLE = 'single';
export const NIST_FACE_SCENARIO_TABLE5_FUSION = 'table5_fusion';
export const NIST_FACE_SCENARIO_TABLE6_MULTI_FACE = 'table6_multi_face';

export const NIST_IRIS_SCENARIO_SINGLE = 'single';
export const NIST_IRIS_SCENARIO_K_FRAME = 'k_frame_enroll';

export const NIST_FACE_MODE_FLAG = 'io.ooru.nist.face.mode';
export const NIST_IRIS_MODE_FLAG = 'io.ooru.nist.iris.mode';

export const NIST_FACE_SCENARIOS = [
  { value: NIST_FACE_SCENARIO_SINGLE, label: 'Single image', hint: 'One image → one BCHQ template' },
  {
    value: NIST_FACE_SCENARIO_TABLE5_FUSION,
    label: 'Table 5 — K-frame fusion',
    hint: 'K images (same person) → one fused BCHQ template',
  },
  {
    value: NIST_FACE_SCENARIO_TABLE6_MULTI_FACE,
    label: 'Table 6 — group photo',
    hint: 'One image → M BCHQ templates (one per detected face)',
  },
];

export const NIST_IRIS_SCENARIOS = [
  { value: NIST_IRIS_SCENARIO_SINGLE, label: 'Single image', hint: 'One iris image → one template' },
  {
    value: NIST_IRIS_SCENARIO_K_FRAME,
    label: 'K-frame enroll',
    hint: 'K frames (same eye) → one BCHI fused template',
  },
];

export const faceScenarioToModeFlag = (scenario) => {
  if (scenario === NIST_FACE_SCENARIO_TABLE5_FUSION) return 'fusion';
  if (scenario === NIST_FACE_SCENARIO_TABLE6_MULTI_FACE) return 'multi_face';
  return 'single';
};

export const irisScenarioToModeFlag = (scenario) => {
  if (scenario === NIST_IRIS_SCENARIO_K_FRAME) return 'k_frame';
  return 'single';
};

/** NIST 1:N match testing scenarios (biosdk-ui HTTP validation). */
export const NIST_FACE_MATCH_1N = 'face_match_1n';
export const NIST_FACE_MATCH_1N_MXN = 'face_match_1n_mxn';
export const NIST_IRIS_MATCH_1N = 'iris_match_1n';

export const NIST_FACE_1N_SCENARIOS = [
  {
    value: NIST_FACE_MATCH_1N,
    label: '1:N — probe vs N gallery',
    hint: 'One probe (image or BCHQ) vs N gallery templates or images via /raw/match gallery[]',
  },
  {
    value: NIST_FACE_MATCH_1N_MXN,
    label: 'Table 6 M×N matrix',
    hint: 'Group photo → M probe BCHQ templates vs N enroll templates; full score matrix',
  },
];

export const NIST_IRIS_1N_SCENARIOS = [
  {
    value: NIST_IRIS_MATCH_1N,
    label: '1:N — probe vs N gallery',
    hint: 'One probe vs N gallery BCHI templates or iris images; rank by ascending dissimilarity',
  },
];
